export interface ImageWorkflowState {
  externalUrl: string | null;
  processedBlob: Blob | null;
  removeExistingImage: boolean;
  processing: boolean;
  progress: number;
}

export const initialImageWorkflowState: ImageWorkflowState = {
  externalUrl: null,
  processedBlob: null,
  removeExistingImage: false,
  processing: false,
  progress: 0,
};

export type ImageWorkflowAction =
  | {
      type: 'set';
      field: keyof ImageWorkflowState;
      value: ImageWorkflowState[keyof ImageWorkflowState];
    }
  | { type: 'reset' };

export const imageWorkflowReducer = (
  state: ImageWorkflowState,
  action: ImageWorkflowAction,
): ImageWorkflowState =>
  action.type === 'reset'
    ? initialImageWorkflowState
    : { ...state, [action.field]: action.value };
